import { Camera } from "lucide-react";

const ITEMS = [
  {
    title: "Drain cleaning & hydro-jetting",
    image:
      "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=1200&auto=format&fit=crop&q=70",
    tag: "Drain Cleaning",
    caption:
      "Machine augering, hydro-jetting, and camera inspection to clear and confirm the fix.",
  },
  {
    title: "Water heater installation",
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&auto=format&fit=crop&q=70",
    tag: "Water Heater",
    caption:
      "Tank and tankless installs, replacements, and same-day service — old unit hauled away.",
  },
  {
    title: "Faucet & fixture repair",
    image:
      "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1200&auto=format&fit=crop&q=70",
    tag: "Fixtures",
    caption:
      "Kitchen and bathroom faucets, disposals, shower valves and toilets — repaired or replaced.",
  },
];

export default function Gallery() {
  return (
    <section className="bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-baseline gap-3">
              <span className="font-display font-black text-sm text-[#A88852]">04 —</span>
              <div className="label-eyebrow">Services in action</div>
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900 max-w-xl">
              The kind of work we do every day.
            </h2>
          </div>
          <p className="text-slate-600 max-w-sm">
            Real, everyday plumbing work — clean job sites, warrantied installs, and jobs done right the first time.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {ITEMS.map((item, i) => (
            <article
              key={i}
              data-testid={`gallery-item-${i}`}
              className="group bg-slate-50 border border-slate-200 rounded-md overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[4/3] bg-slate-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-xs text-orange-600 font-bold uppercase tracking-wider">
                  <Camera size={12} /> {item.tag}
                </div>
                <h3 className="font-display text-lg font-bold text-slate-900 mt-1.5">{item.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{item.caption}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
